<template>
    <div>
        <h2 class="h2">Položky v katalogu</h2>
        <catalogue-column-offer/>
        <catalogue-column-selected/>
    </div>
</template>

<script>
import CatalogueColumnOffer
    from '@/modules/ProjectModule/modules/ExtensionModule/components/Catalogue/Column/CatalogueColumnOffer';
import CatalogueColumnSelected
    from '@/modules/ProjectModule/modules/ExtensionModule/components/Catalogue/Column/CatalogueColumnSelected';

export default {
    name:       'CatalogueColumnContainer',
    components: {
        CatalogueColumnSelected,
        CatalogueColumnOffer,
    }
}
</script>
